import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EntityService } from '../../entity.service'

@Component({
  selector: 'app-add-document',
  templateUrl: './add-document.component.html',
  styleUrls: ['./add-document.component.scss']
})
export class AddDocumentComponent implements OnInit {
  @ViewChild('deleteDcmntCnfrmDialog') deleteDcmntCnfrmDialog: TemplateRef<any>;
  shwinpt: boolean=true;
  dcmnt_ctgry_id: any;
  dcmnt_ctgry_nm: any;
  fldrdata: any;
  fldr_pth: any;
  constructor(public matDialogRef: MatDialogRef<AddDocumentComponent>,
    public _documentService: EntityService, @Inject(MAT_DIALOG_DATA) public dialogData: any, private _matDialog: MatDialog) { }
  dcmntCtgryLst
  dcmnt_ctgry
  dcmntTypLst = []
  dcmnt_type_id
  attachments = []
  fl_nm
  fl_type
  enty_ky
  accept
  hndlr_nm
  shwUpld: boolean = false
  editData
  hdng_nm
  sve_btn
  max_mg_ct
  loader
  deleteDialog
  showNtRegdDiv
  err_msg = ''
  ngOnInit(): void {
    console.log(this.dialogData)
    if(this.dialogData.fldr_id){
      console.log("kkkkkkkkkkkkkkkkkkkkkkk")
      this.shwUpld=true
      this.shwinpt=false
      this.dcmnt_ctgry_id=this.dialogData.dcmnt_ctgry_id
      this.fldrdata = this.dialogData
      this.fldr_pth=this.dialogData.fldr_pth
    }
    if (this.dialogData) {
      if (this.dialogData.edit_in) {
        this.hndlr_nm = this.dialogData.hndlr_nm;
        this.enty_ky = this.dialogData.enty_ky;
        this.editData = this.dialogData.editData;
        this.hdng_nm = 'Edit';
        this.sve_btn = 'Update';
        this.getDcmntCtgry()
      }
      else {
        this.hndlr_nm = this.dialogData.hndlr_nm;
        this.enty_ky = this.dialogData.enty_ky;
        this.hdng_nm = 'Add';
        this.sve_btn = 'Add';
        this.getDcmntCtgry()
      }

    }
    else {
      this.hndlr_nm = 'documents';
      this.enty_ky = 1;
      this.hdng_nm = 'Add';
      this.sve_btn = 'Add';
      this.getDcmntCtgry()
    }

  }
  Close() {
    this.matDialogRef.close();
  }

  getDcmntCtgry() {
    this._documentService.get_document_categories(this.hndlr_nm).subscribe((res) => {
      if (res['status'] == 200) {
        this.dcmntCtgryLst = res['data']
        if (this.dcmntCtgryLst.length == 1) {
          this.dcmnt_ctgry = this.dcmntCtgryLst[0]
          this.onCtgryChnge(this.dcmntCtgryLst[0])
        }
        if (this.editData) {
          this.dcmntCtgryLst.filter((d) => {
            if (d.dcmnt_ctgry_id == this.editData.dcmnt_ctgry_id) {
              this.dcmnt_ctgry = d;
              this.dcmnt_ctgry_nm=this.dcmnt_ctgry.dcmnt_ctgry_nm
              this.onCtgryChnge(this.dcmnt_ctgry)
              this.edtFnc()
            }
           
          })
        }
        if (this.fldrdata) {
          this.dcmntCtgryLst.filter((d) => {
            if (d.dcmnt_ctgry_id == this.fldrdata.dcmnt_ctgry_id) {
              this.dcmnt_ctgry = d;
              this.dcmnt_ctgry_nm=this.dcmnt_ctgry.dcmnt_ctgry_nm
              console.log(d)
              // this.onCtgryChnge(this.dcmnt_ctgry)
              // this.edtFnc()
            }
           
          })
        }
      }
      else {
        this._documentService.openSnackBar(res['message'], 'mat-warn');
      }
    })
  }
  edtFnc() {
    this.loader = true
    this.dcmnt_type_id = this.editData.dcmnt_type_id;
    this.attachments.push(
      {
        fl_type: this.editData.dcmnt_type_nm,
        fl_name: this.editData.dcmnt_nm,
        base64: this.editData.dcmnt_url_tx,
        isNew: false
      });
    this.shwUpld = true
    this.max_mg_ct = this.attachments.length
    if (this.editData.dcmnt_type_nm == 'Image') {
      this.accept = "image/png,image/jpeg,image/jpg";
    }
    if (this.editData.dcmnt_type_nm == 'Word') {
      this.accept = "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    }
    if (this.editData.dcmnt_type_nm == 'PDF') {
      this.accept = "application/pdf"
    }
    if (this.editData.dcmnt_type_nm == 'Excel') {
      this.accept = "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
    this.loader = false
  }
  onCtgryChnge(e) {
    if (this.editData) {
      this.max_mg_ct = this.attachments.length
    }
    else {
      this.max_mg_ct = e.mx_ct
    }
    this.shwUpld = true
  }
  getDcmntTyps(dcmnt_ctgry_id) {
    this._documentService.get_document_types(dcmnt_ctgry_id).subscribe((res) => {
      if (res['status'] == 200) {
        this.dcmntTypLst = res['data']
        this.shwUpld = true
      }
      else {
        this.shwUpld = false
        this._documentService.openSnackBar(res['message'], 'mat-warn');
      }
    })
  }
  send() {

    if (this.editData) {
      if (this.dcmnt_ctgry) {
        this.loader = true;
        let postData = {
          dcmnt_ctgry_id: this.dcmnt_ctgry.dcmnt_ctgry_id,
          dcmnt_type_id: this.dcmnt_type_id,
          attachments: this.attachments,
          hndlr_nm: this.hndlr_nm,
          enty_ky: this.enty_ky,
          dcmnt_id: this.editData.dcmnt_id,
          dcmnt_in: this.editData.dcmnt_in
        }
        this._documentService.updte_document(postData).subscribe((res) => {
          this.loader = false
          if (res['status'] == 200) {
            this.matDialogRef.close();
            this._documentService.openSnackBar("file added successfully", 'mat-primary');
          }
          else {
            this._documentService.openSnackBar(res['message'], 'mat-warn');
          }
        })
      }
      else {
        this._documentService.openSnackBar('Please Select Document Category', 'mat-warn');
      }

    }
    else {
      if (this.dcmnt_ctgry) {
         console.log(this.fldrdata)
        this.loader = true
        let postData = {
          dcmnt_ctgry_id: this.dcmnt_ctgry.dcmnt_ctgry_id,
          attachments: this.attachments,
          hndlr_nm: this.hndlr_nm,
          enty_ky: this.enty_ky,
          prnt_fldr_id:this.fldrdata && this.fldrdata.fldr_id?this.fldrdata.fldr_id:0

        }
        this._documentService.new_document(postData).subscribe((res) => {
          this.loader = false
          if (res['status'] == 200) {
            this.matDialogRef.close();
            this._documentService.openSnackBar(res['message'], 'mat-primary');
          }
          else {
            this._documentService.openSnackBar(res['message'], 'mat-warn');
          }
        })
      }
      else {
        this._documentService.openSnackBar('Please Select Document Category', 'mat-warn');
      }

    }

  }
  handleInputChange(e) {
    let files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    for (var i = 0; i < files.length; i++) {
      if (files[i].size < 10485760) // checking file size less than 10 mb
      {
        this.showNtRegdDiv = false
        if (files[i].type == 'application/msword' || files[i].type == 'application/vnd.ms-excel' || files[i].type == 'image/jpeg' || files[i].type == 'image/png' || files[i].type == 'image/jpg' || files[i].type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || files[i].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || files[i].type == 'application/pdf') {
          let file = files[i];
          this.fl_type = file.type;
          this.fl_nm = file.name;
          let reader = new FileReader();
          reader.onload = this._handleReaderLoaded.bind(this);
          reader.readAsDataURL(file);
        }
        else {
          this.showNtRegdDiv = true;
          this.err_msg = 'Please upload a valid file.';
        }
      }
      else {
        this.showNtRegdDiv = true;
        this.err_msg = 'Please upload file less than 10MB.';
      }

    }
  }

  _handleReaderLoaded(e) {
    var reader = e.target;

    this.attachments.push(
      {
        fl_type: this.fl_type,
        fl_name: this.fl_nm,
        base64: reader.result
      });
    if (this.editData) {
      this.attachments[0]['isNew'] = true
    }
  }

  removeImg(val) {
    const idx = this.attachments.indexOf(val);
    if (idx !== -1) {
      this.attachments.splice(idx, 1);
    }
  }
  onTypChnge(e) {
    console.log(e)
    this.accept = ''
    if (e.value == 1) {
      this.accept = "image/png,image/jpeg,image/jpg";
    }
    if (e.value == 2) {
      this.accept = "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    }
    if (e.value == 3) {
      this.accept = "application/pdf"
    }
    if (e.value == 4) {
      this.accept = "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }

  delete() {
    this.deleteDialog = this._matDialog.open(this.deleteDcmntCnfrmDialog);
  }
  deleteDcmnt() {
    this.deleteDialog.close()
    this.loader = true;
    this._documentService.remove_document(this.editData.dcmnt_id).subscribe((res) => {
      this.loader = false
      if (res['status'] == 200) {
        this.matDialogRef.close();
        this._documentService.openSnackBar(res['message'], 'mat-primary');
      }
      else {
        this._documentService.openSnackBar(res['message'], 'mat-warn');
      }
    })
  }
  closeDialog() {
    this.deleteDialog.close()
  }
}
